<template>
  <v-container>
    <v-row>
    	<v-col cols="12">
    		<v-card>
    		  <v-card-title primary-title>
    		    Notificación
    		  </v-card-title>

    		  <!-- Token -->
    		  <div class="ml-4">{{ tokenFirebase }}</div>

    		  <br/>
    		  <br/>
    		  <br/>

    		  <v-card-actions class="ml-2">
    		    <v-btn color="primary" rounded @click="initialize( )">iniciar</v-btn>
    		  </v-card-actions>

    		</v-card>
    	</v-col>
    </v-row>
  </v-container>
</template>

<script>
	// import {
	//   ActionPerformed,
  //   PushNotificationSchema,
	//   PushNotifications,
	//   Token,
	// } from '@capacitor/push-notifications';
	// import { Capacitor } from '@capacitor/core';

  export default {
  	data: () => ({
  		tokenFirebase:'eeee',
  	}),

  	methods:{
  		async initialize ( ) {
			  // console.log('Initializing HomePage');
			  // if (!Capacitor.isNativePlatform()) {
			  //   this.tokenFirebase = 'PushNotifications no disponible en web';
			  //   return;
			  // }
			  //
		    // // Request permission to use push notifications
		    // // iOS will prompt user and return if they granted permission or not
		    // // Android will just grant without prompting
		    // PushNotifications.requestPermissions().then(result => {
		    //   if (result.receive === 'granted') {
		    //     // Register with Apple / Google to receive push via APNS/FCM
		    //     PushNotifications.register();
		    //   } else {
		    //     // Show some error
		    //   }
		    // });
			  //
		    // // Registrar el dispositivo y regresar el token
		    // PushNotifications.addListener('registration', token => {
		    // 	this.tokenFirebase = token.value
	      //   console.info('Push registration success, token: ' + token.value);
	      // });
			  //
		    // // Some issue with our setup and push will not work
		    // PushNotifications.addListener('registrationError', error => {
	      //   console.info('Error on registration: ' + JSON.stringify(error));
	      // });
			  //
		    // // Show us the notification payload if the app is open on our device
		    // PushNotifications.addListener('pushNotificationReceived', notification => {
	      //   alert('Push received: ' + JSON.stringify(notification));
	      // });
			  //
		    // // Method called when tapping on a notification
		    // PushNotifications.addListener('pushNotificationActionPerformed', notification => {
	      //   alert('Push action performed: ' + JSON.stringify(notification));
	      // });
  		},

  		async listarNotificaciones( ){
  		},

  		async obtenerToken ( ){
  			
  		}
  	}
  };
</script>